import { DefaultTemplate, COR, CORES_SIM_NAO, CORES_PRIORIDADE } from './types';

// ============================================================
// SETORES NOVOS — Marketing, Logística/Estoque, Qualidade, Manutenção
// ============================================================

const campanhasMarketing: DefaultTemplate = {
  id: 'tpl_campanhas_marketing',
  name: 'Campanhas de Marketing',
  descricao: 'Do briefing ao relatório de resultado: aprovação de verba, produção criativa, revisão, veiculação e medição de ROI. Para o marketing provar o que gerou, não só o que postou.',
  categoria: 'marketing',
  icone: '📣',
  etiquetas: [
    { nome: 'Lançamento', cor: COR.roxo },
    { nome: 'Sazonal', cor: COR.amarelo },
    { nome: 'Performance', cor: COR.azul },
  ],
  etapas: [
    {
      id: 'mk_e1', nome: 'Briefing',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['mk_c1', 'mk_b2', 'mk_b4'],
      permiteMoverPara: ['mk_e2'],
      // Formulário "Briefing para Criação de Peças" do Marketing. Obrigatórios são os
      // que têm * no formulário original. mk_c1 mantém o id: é o título do card e
      // aparece no mini card de todas as etapas.
      campos: [
        { id: 'mk_s0', nome: 'Informações da solicitação', tipo: 'texto_informativo', obrigatorio: false, ocultarTitulo: true, textoInformativo: 'Informações da solicitação' },
        { id: 'mk_b1', nome: 'Solicitante', tipo: 'texto', obrigatorio: true },
        { id: 'mk_b2', nome: 'Área', tipo: 'lista', obrigatorio: true, opcoes: ['Comercial', 'E-commerce', 'Televendas', 'Loja / Operações', 'CD / Logística', 'Compras', 'Financeiro', 'RH', 'TI', 'Diretoria', 'Outra'] },
        { id: 'mk_b3', nome: 'Data da solicitação', tipo: 'data', obrigatorio: true },
        { id: 'mk_b4', nome: 'Data necessária para entrega', tipo: 'data_vencimento', obrigatorio: true },

        { id: 'mk_s1', nome: '1. O que precisa ser criado?', tipo: 'texto_informativo', obrigatorio: false, ocultarTitulo: true, textoInformativo: '1. O que precisa ser criado? Marque uma ou mais opções.' },
        { id: 'mk_b5', nome: 'O que precisa ser criado', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Post para Instagram', 'Story', 'Banner para site', 'E-mail marketing', 'WhatsApp', 'Material impresso', 'Anúncio / mídia paga', 'Outro'] },
        { id: 'mk_b6', nome: 'Outro (o que precisa ser criado) — especifique', tipo: 'texto', obrigatorio: false },

        { id: 'mk_s2', nome: '2. Qual o objetivo da peça?', tipo: 'texto_informativo', obrigatorio: false, ocultarTitulo: true, textoInformativo: '2. Qual o objetivo da peça? Marque uma ou mais opções.' },
        { id: 'mk_b7', nome: 'Objetivo da peça', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Venda', 'Divulgação de produto', 'Promoção', 'Evento', 'Comunicação interna', 'Institucional', 'Outro'] },
        { id: 'mk_b8', nome: 'Outro (objetivo) — especifique', tipo: 'texto', obrigatorio: false },

        { id: 'mk_s3', nome: '3. Público-alvo', tipo: 'texto_informativo', obrigatorio: false, ocultarTitulo: true, textoInformativo: '3. Público-alvo: para quem essa comunicação será direcionada?' },
        { id: 'mk_b9', nome: 'Público-alvo', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Cliente final', 'Parceiro', 'Instalador', 'Loja', 'Colaborador', 'Outro'] },
        { id: 'mk_b10', nome: 'Outro (público-alvo) — especifique', tipo: 'texto', obrigatorio: false },

        { id: 'mk_s4', nome: '4. Conteúdo', tipo: 'texto_informativo', obrigatorio: false, ocultarTitulo: true, textoInformativo: '4. Conteúdo' },
        { id: 'mk_c1', nome: 'Título / chamada principal', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'mk_b11', nome: 'Texto / informações que precisam aparecer', tipo: 'texto_longo', obrigatorio: true },

        { id: 'mk_s5', nome: '5. Informações obrigatórias', tipo: 'texto_informativo', obrigatorio: false, ocultarTitulo: true, textoInformativo: '5. Informações obrigatórias: chamada, preço, desconto, período da promoção, regulamento, endereço, telefone, QR Code, marcas, logos ou outras informações.' },
        { id: 'mk_b12', nome: 'Informações obrigatórias', tipo: 'texto_longo', obrigatorio: false },

        { id: 'mk_s6', nome: '6. Referências', tipo: 'texto_informativo', obrigatorio: false, ocultarTitulo: true, textoInformativo: '6. Referências: existe alguma peça, imagem, campanha ou estilo que deve ser usado como referência?' },
        { id: 'mk_b13', nome: 'Referências (descreva ou cole links)', tipo: 'texto_longo', obrigatorio: false },
        { id: 'mk_b14', nome: 'Arquivos de referência', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'mk_e2', nome: 'Aprovação de Verba',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['mk_c1', 'mk_b4', 'mk_c9'],
      permiteMoverPara: ['mk_e3', 'mk_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'mk_c9', nome: 'Aprovada?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mk_c10', nome: 'Verba Liberada', tipo: 'valor', obrigatorio: false },
        { id: 'mk_c11', nome: 'Observação', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'mk_e3', nome: 'Produção Criativa',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['mk_c1', 'mk_c13'],
      permiteMoverPara: ['mk_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'mk_c12', nome: 'Responsável Criativo', tipo: 'texto', obrigatorio: false },
        { id: 'mk_c13', nome: 'Progresso da Produção', tipo: 'progresso', obrigatorio: false },
        { id: 'mk_c14', nome: 'Peças Necessárias', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Post estático', 'Carrossel', 'Vídeo / Reels', 'Landing page', 'E-mail', 'Banner', 'Material impresso'] },
        { id: 'mk_c15', nome: 'Arquivos das Peças', tipo: 'anexo', obrigatorio: false },
        { id: 'mk_c16', nome: 'Produção concluída?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'mk_e4', nome: 'Revisão e Aprovação',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['mk_c1', 'mk_c17'],
      permiteMoverPara: ['mk_e5', 'mk_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'mk_c17', nome: 'Peças aprovadas?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mk_c18', nome: 'Ajustes Solicitados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'mk_c19', nome: 'Revisor', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'mk_e5', nome: 'Em Veiculação',
      camposVisiveisNoCard: ['mk_c1', 'mk_c20', 'mk_c21'],
      permiteMoverPara: ['mk_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'mk_c20', nome: 'Data de Início', tipo: 'data', obrigatorio: false },
        { id: 'mk_c21', nome: 'Data de Término', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'mk_c22', nome: 'Investimento Realizado', tipo: 'valor', obrigatorio: false },
        { id: 'mk_c23', nome: 'Acompanhamento Parcial', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'mk_e6', nome: 'Resultado / Relatório',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['mk_c1', 'mk_c25', 'mk_c27'],
      permiteCriarCards: false,
      campos: [
        { id: 'mk_c24', nome: 'Alcance / Impressões', tipo: 'numero', obrigatorio: false },
        { id: 'mk_c25', nome: 'Leads Gerados', tipo: 'numero', obrigatorio: false },
        { id: 'mk_c26', nome: 'Vendas Atribuídas', tipo: 'valor', obrigatorio: false },
        { id: 'mk_c27', nome: 'Custo por Lead', tipo: 'valor', obrigatorio: false },
        { id: 'mk_c28', nome: 'Atingiu a meta?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Parcialmente', 'Não'], coresOpcoes: { 'Sim': COR.verde, 'Parcialmente': COR.amarelo, 'Não': COR.vermelho } },
        { id: 'mk_c29', nome: 'Aprendizados', tipo: 'texto_longo', obrigatorio: false },
        { id: 'mk_c30', nome: 'Relatório', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'mk_e7', nome: 'Não Aprovada',
      camposVisiveisNoCard: ['mk_c1', 'mk_c31'],
      permiteMoverPara: ['mk_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'mk_c31', nome: 'Motivo', tipo: 'texto_longo', obrigatorio: true },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Verba aprovada libera a produção',
      etapaOrigemId: 'mk_e2',
      condicao: { campoId: 'mk_c9', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mk_e3',
      etapaDestinoSenaoId: 'mk_e7',
    },
    {
      tipo: 'mover',
      nome: 'Produção concluída vai para revisão',
      etapaOrigemId: 'mk_e3',
      condicao: { campoId: 'mk_c16', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mk_e4',
    },
    {
      tipo: 'mover',
      nome: 'Peças aprovadas entram em veiculação',
      etapaOrigemId: 'mk_e4',
      condicao: { campoId: 'mk_c17', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mk_e5',
      etapaDestinoSenaoId: 'mk_e3',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar ajustes quando reprovar as peças',
      etapaOrigemId: 'mk_e4',
      condicao: { campoId: 'mk_c17', operador: 'igual', valor: 'Não' },
      camposAfetadosIds: ['mk_c18'],
    },
  ],
  cards: [
    { id: 'mk_card1', titulo: 'Black Friday 2026', etapaId: 'mk_e3', etiquetas: ['Sazonal', 'Performance'], valores: { mk_c1: 'Black Friday 2026', mk_c2: 'Gerar leads', mk_c3: 'Clientes da base + lookalike', mk_c6: 45000, mk_c10: 40000, mk_c13: 65 } },
    { id: 'mk_card2', titulo: 'Lançamento do módulo financeiro', etapaId: 'mk_e5', etiquetas: ['Lançamento'], valores: { mk_c1: 'Lançamento do módulo financeiro', mk_c2: 'Lançamento de produto', mk_c3: 'Clientes atuais', mk_c6: 18000, mk_c22: 12400 } },
    { id: 'mk_card3', titulo: 'Campanha de reativação', etapaId: 'mk_e6', valores: { mk_c1: 'Campanha de reativação', mk_c2: 'Reativação de clientes', mk_c3: 'Clientes inativos há 6 meses', mk_c25: 84, mk_c27: 62, mk_c28: 'Parcialmente' } },
    { id: 'mk_card4', titulo: 'Presença na feira do setor', etapaId: 'mk_e2', valores: { mk_c1: 'Presença na feira do setor', mk_c2: 'Reconhecimento de marca', mk_c3: 'Indústria de médio porte', mk_c6: 62000 } },
    { id: 'mk_card5', titulo: 'Série de conteúdo no LinkedIn', etapaId: 'mk_e4', valores: { mk_c1: 'Série de conteúdo no LinkedIn', mk_c2: 'Institucional', mk_c3: 'Decisores C-level', mk_c6: 6000 } },
    { id: 'mk_card6', titulo: 'Patrocínio de podcast', etapaId: 'mk_e7', valores: { mk_c1: 'Patrocínio de podcast', mk_c2: 'Reconhecimento de marca', mk_c3: 'Público amplo', mk_c31: 'Sem métrica clara de retorno para o investimento pedido.' } },
  ],
  tour: [
    '📣 Campanha com verba controlada e resultado medido.',
    '1️⃣ "Briefing": objetivo, público, canais e meta numérica — sem meta não dá para provar nada.',
    '2️⃣ "Aprovação de Verba": aprovou libera a produção; reprovou registra o motivo.',
    '3️⃣ "Produção Criativa": barra de progresso e checklist de peças.',
    '4️⃣ "Revisão": reprovou? volta para produção com os ajustes listados.',
    '5️⃣ "Em Veiculação": investimento realizado acompanhado em tempo real.',
    '📊 "Resultado": leads, custo por lead e vendas atribuídas — ROI na mesa.',
  ],
  etapasDicas: [
    { quemFaz: 'Marketing', objetivo: 'Definir objetivo e meta antes de pensar em criativo.' },
    { quemFaz: 'Diretoria', objetivo: 'Liberar verba com clareza do retorno esperado.', automacoes: ['Já configurado: aprovada libera a produção'] },
    { quemFaz: 'Designer / Agência', objetivo: 'Produzir as peças com progresso visível.' },
    { quemFaz: 'Gerente de Marketing', objetivo: 'Revisar antes de publicar — erro no ar custa caro.', automacoes: ['Já configurado: reprovado volta para produção'] },
    { quemFaz: 'Marketing / Mídia', objetivo: 'Acompanhar investimento e performance durante a veiculação.' },
    { quemFaz: 'Marketing', objetivo: 'Fechar com números reais e aprendizados para a próxima.', conexoes: ['Ligue ao Pipeline de Vendas para atribuir os leads gerados'] },
    { quemFaz: 'Marketing', objetivo: 'Guardar o motivo da recusa para reapresentar a campanha melhor.' },
  ],
};

const controleEstoque: DefaultTemplate = {
  id: 'tpl_controle_estoque',
  name: 'Movimentação de Estoque',
  descricao: 'Entrada, conferência, endereçamento, separação e expedição com controle de divergências e inventário. Para almoxarifado e CD que precisam saber onde cada item está.',
  categoria: 'logistica',
  icone: '📦',
  etiquetas: [
    { nome: 'Divergência', cor: COR.vermelho },
    { nome: 'Urgente', cor: COR.amarelo },
    { nome: 'Frágil', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'es_e1', nome: 'Recebimento',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['es_c1', 'es_c3', 'es_c5'],
      permiteMoverPara: ['es_e2'],
      campos: [
        { id: 'es_c1', nome: 'Descrição da Carga', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'es_c2', nome: 'Fornecedor', tipo: 'texto', obrigatorio: true },
        { id: 'es_c3', nome: 'Nº da Nota Fiscal', tipo: 'texto', obrigatorio: true },
        { id: 'es_c4', nome: 'Nota Fiscal', tipo: 'anexo', obrigatorio: false },
        { id: 'es_c5', nome: 'Data do Recebimento', tipo: 'data', obrigatorio: true },
        { id: 'es_c6', nome: 'Nº do Pedido de Compra', tipo: 'texto', obrigatorio: false },
        { id: 'es_c7', nome: 'Volumes Recebidos', tipo: 'numero', obrigatorio: false },
        { id: 'es_c8', nome: 'Transportadora', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'es_e2', nome: 'Conferência',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['es_c1', 'es_c10'],
      permiteMoverPara: ['es_e3', 'es_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'es_c9', nome: 'Conferente', tipo: 'texto', obrigatorio: false },
        { id: 'es_c10', nome: 'Confere com a NF?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'es_c11', nome: 'Quantidade Conferida', tipo: 'numero', obrigatorio: false },
        { id: 'es_c12', nome: 'Estado da Mercadoria', tipo: 'lista', obrigatorio: false, opcoes: ['Perfeito', 'Avaria leve', 'Avaria grave'], coresOpcoes: { 'Perfeito': COR.verde, 'Avaria leve': COR.amarelo, 'Avaria grave': COR.vermelho } },
        { id: 'es_c13', nome: 'Foto da Conferência', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'es_e3', nome: 'Endereçamento',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['es_c1', 'es_c14'],
      permiteMoverPara: ['es_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'es_c14', nome: 'Endereço no Estoque', tipo: 'texto', obrigatorio: true },
        { id: 'es_c15', nome: 'Lançado no sistema?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'es_c16', nome: 'Lote / Validade', tipo: 'texto', obrigatorio: false },
        { id: 'es_c17', nome: 'Responsável', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'es_e4', nome: 'Disponível em Estoque',
      camposVisiveisNoCard: ['es_c1', 'es_c14', 'es_c18'],
      permiteMoverPara: ['es_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'es_c18', nome: 'Quantidade em Estoque', tipo: 'numero', obrigatorio: false },
        { id: 'es_c19', nome: 'Estoque Mínimo', tipo: 'numero', obrigatorio: false },
        { id: 'es_c20', nome: 'Abaixo do mínimo?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'es_e5', nome: 'Separação / Expedição',
      tempoMaximoHoras: 24,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['es_c1', 'es_c21', 'es_c24'],
      permiteMoverPara: ['es_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'es_c21', nome: 'Destino / Cliente', tipo: 'texto', obrigatorio: true },
        { id: 'es_c22', nome: 'Quantidade Separada', tipo: 'numero', obrigatorio: false },
        { id: 'es_c23', nome: 'Separado por', tipo: 'texto', obrigatorio: false },
        { id: 'es_c24', nome: 'Data Prevista de Saída', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'es_c25', nome: 'Conferência de saída OK?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'es_e6', nome: 'Divergência',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['es_c1', 'es_c26'],
      permiteMoverPara: ['es_e2', 'es_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'es_c26', nome: 'Tipo de Divergência', tipo: 'lista', obrigatorio: true, opcoes: ['Quantidade a maior', 'Quantidade a menor', 'Item errado', 'Avaria', 'NF incorreta', 'Sem pedido'], coresOpcoes: { 'Avaria': COR.vermelho, 'Item errado': COR.amarelo } },
        { id: 'es_c27', nome: 'Descrição', tipo: 'texto_longo', obrigatorio: true },
        { id: 'es_c28', nome: 'Evidência', tipo: 'anexo', obrigatorio: false },
        { id: 'es_c29', nome: 'Fornecedor notificado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'es_c30', nome: 'Resolvida?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'es_e7', nome: 'Expedido',
      camposVisiveisNoCard: ['es_c1', 'es_c21'],
      permiteCriarCards: false,
      campos: [
        { id: 'es_c31', nome: 'Data da Saída', tipo: 'data', obrigatorio: false },
        { id: 'es_c32', nome: 'Nº do Romaneio / CTe', tipo: 'texto', obrigatorio: false },
        { id: 'es_c33', nome: 'Comprovante de Entrega', tipo: 'anexo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Conferência OK segue para endereçamento',
      etapaOrigemId: 'es_e2',
      condicao: { campoId: 'es_c10', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'es_e3',
      etapaDestinoSenaoId: 'es_e6',
    },
    {
      tipo: 'mover',
      nome: 'Lançado no sistema fica disponível em estoque',
      etapaOrigemId: 'es_e3',
      condicao: { campoId: 'es_c15', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'es_e4',
    },
    {
      tipo: 'mover',
      nome: 'Divergência resolvida volta para conferência',
      etapaOrigemId: 'es_e6',
      condicao: { campoId: 'es_c30', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'es_e2',
    },
    {
      tipo: 'mover',
      nome: 'Conferência de saída OK expede a carga',
      etapaOrigemId: 'es_e5',
      condicao: { campoId: 'es_c25', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'es_e7',
    },
  ],
  cards: [
    { id: 'es_card1', titulo: 'Embalagens - lote 4420', etapaId: 'es_e4', valores: { es_c1: 'Embalagens - lote 4420', es_c2: 'Embalagens Prima', es_c3: '018452', es_c14: 'A-12-03', es_c18: 4200, es_c19: 1000 } },
    { id: 'es_card2', titulo: 'Componentes eletrônicos', etapaId: 'es_e6', etiquetas: ['Divergência'], valores: { es_c1: 'Componentes eletrônicos', es_c2: 'Info Peças Comércio', es_c3: '007731', es_c26: 'Quantidade a menor', es_c27: 'NF indica 500 unidades, chegaram 460.' } },
    { id: 'es_card3', titulo: 'Pedido 3382 - Rede Farmácia', etapaId: 'es_e5', etiquetas: ['Urgente'], valores: { es_c1: 'Pedido 3382 - Rede Farmácia', es_c21: 'Rede Farmácia Vida', es_c22: 120 } },
    { id: 'es_card4', titulo: 'Matéria-prima - aço', etapaId: 'es_e2', valores: { es_c1: 'Matéria-prima - aço', es_c2: 'Metalúrgica Souza Ltda', es_c3: '445120' } },
    { id: 'es_card5', titulo: 'Pedido 3350 - Grupo Andrade', etapaId: 'es_e7', valores: { es_c1: 'Pedido 3350 - Grupo Andrade', es_c21: 'Grupo Andrade', es_c32: 'ROM-2026-0881' } },
    { id: 'es_card6', titulo: 'Equipamentos de informática', etapaId: 'es_e1', etiquetas: ['Frágil'], valores: { es_c1: 'Equipamentos de informática', es_c2: 'Dell Brasil', es_c3: '992014' } },
  ],
  tour: [
    '📦 Cada carga é um cartão — do caminhão à expedição.',
    '1️⃣ "Recebimento": NF, volumes e transportadora.',
    '2️⃣ "Conferência": bateu com a NF? segue. Não bateu? vai para "Divergência" sozinho.',
    '3️⃣ "Endereçamento": onde o item ficou guardado + lançamento no sistema.',
    '4️⃣ "Disponível em Estoque": quantidade e alerta de estoque mínimo.',
    '5️⃣ "Separação / Expedição": ordenada por data de saída prevista.',
    '⚠️ "Divergência" tem trilha própria com evidência e notificação ao fornecedor.',
  ],
  etapasDicas: [
    { quemFaz: 'Portaria / Almoxarifado', objetivo: 'Registrar a chegada com NF e volumes.', conexoes: ['Ligue à Requisição de Compra para casar a entrega com o pedido'] },
    { quemFaz: 'Conferente', objetivo: 'Conferir antes de aceitar — depois de aceito, o problema é seu.', automacoes: ['Já configurado: divergência abre trilha própria'] },
    { quemFaz: 'Almoxarife', objetivo: 'Endereçar e lançar no sistema — item sem endereço é item perdido.' },
    { quemFaz: 'Almoxarife', objetivo: 'Manter saldo visível e sinalizar reposição.', conexoes: ['Ligue à Requisição de Compra para repor automaticamente'] },
    { quemFaz: 'Separador / Expedição', objetivo: 'Separar e conferir a saída antes de despachar.' },
    { quemFaz: 'Almoxarifado + Compras', objetivo: 'Tratar a divergência com o fornecedor e registrar evidência.' },
    { quemFaz: 'Expedição', objetivo: 'Fechar com romaneio e comprovante de entrega.' },
  ],
};

const naoConformidades: DefaultTemplate = {
  id: 'tpl_nao_conformidades',
  name: 'Não Conformidades (SGQ)',
  descricao: 'Registro de NC com análise de causa raiz (5 porquês / Ishikawa), ação corretiva, verificação de eficácia e encerramento. Pronto para auditoria ISO 9001.',
  categoria: 'qualidade',
  icone: '✅',
  etiquetas: [
    { nome: 'Reincidente', cor: COR.vermelho },
    { nome: 'Auditoria', cor: COR.roxo },
    { nome: 'Cliente', cor: COR.azul },
  ],
  etapas: [
    {
      id: 'nc_e1', nome: 'Registro da NC',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['nc_c1', 'nc_c3', 'nc_c5'],
      permiteMoverPara: ['nc_e2'],
      campos: [
        { id: 'nc_c1', nome: 'Descrição da Não Conformidade', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'nc_c2', nome: 'Detalhamento', tipo: 'texto_longo', obrigatorio: true },
        { id: 'nc_c3', nome: 'Origem', tipo: 'lista', obrigatorio: true, opcoes: ['Auditoria interna', 'Auditoria externa', 'Reclamação de cliente', 'Processo produtivo', 'Fornecedor', 'Observação interna'], coresOpcoes: { 'Auditoria externa': COR.roxo, 'Reclamação de cliente': COR.azul } },
        { id: 'nc_c4', nome: 'Processo Afetado', tipo: 'lista', obrigatorio: true, opcoes: ['Comercial', 'Compras', 'Produção', 'Logística', 'Atendimento', 'Financeiro', 'RH'] },
        { id: 'nc_c5', nome: 'Severidade', tipo: 'lista', obrigatorio: true, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
        { id: 'nc_c6', nome: 'Detectado por', tipo: 'texto', obrigatorio: false },
        { id: 'nc_c7', nome: 'Evidência', tipo: 'anexo', obrigatorio: false },
        { id: 'nc_c8', nome: 'É reincidente?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'nc_e2', nome: 'Contenção Imediata',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['nc_c1', 'nc_c9'],
      permiteMoverPara: ['nc_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'nc_c9', nome: 'Ação de Contenção', tipo: 'texto_longo', obrigatorio: true },
        { id: 'nc_c10', nome: 'Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'nc_c11', nome: 'Contenção aplicada?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'nc_c12', nome: 'Produto/serviço bloqueado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'nc_e3', nome: 'Análise de Causa Raiz',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['nc_c1', 'nc_c14'],
      permiteMoverPara: ['nc_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'nc_c13', nome: 'Método Utilizado', tipo: 'lista', obrigatorio: false, opcoes: ['5 Porquês', 'Ishikawa (espinha de peixe)', 'Pareto', 'Brainstorming'] },
        { id: 'nc_c14', nome: 'Causa Raiz Identificada', tipo: 'texto_longo', obrigatorio: true },
        { id: 'nc_c15', nome: 'Categoria da Causa', tipo: 'lista', obrigatorio: false, opcoes: ['Método', 'Máquina', 'Mão de obra', 'Material', 'Medição', 'Meio ambiente'] },
        { id: 'nc_c16', nome: 'Análise Documentada', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'nc_e4', nome: 'Plano de Ação',
      tempoMaximoHoras: 240,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['nc_c1', 'nc_c19'],
      permiteMoverPara: ['nc_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'nc_c17', nome: 'Ações Corretivas (o quê)', tipo: 'texto_longo', obrigatorio: true },
        { id: 'nc_c18', nome: 'Responsável pela Ação', tipo: 'texto', obrigatorio: true },
        { id: 'nc_c19', nome: 'Prazo', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'nc_c20', nome: 'Progresso', tipo: 'progresso', obrigatorio: false },
        { id: 'nc_c21', nome: 'Ações concluídas?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'nc_c22', nome: 'Precisa mudar procedimento?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'nc_e5', nome: 'Verificação de Eficácia',
      tempoMaximoHoras: 720,
      camposVisiveisNoCard: ['nc_c1', 'nc_c24'],
      permiteMoverPara: ['nc_e6', 'nc_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'nc_c23', nome: 'Data da Verificação', tipo: 'data', obrigatorio: false },
        { id: 'nc_c24', nome: 'Problema voltou a ocorrer?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'nc_c25', nome: 'Evidência da Eficácia', tipo: 'texto_longo', obrigatorio: false },
        { id: 'nc_c26', nome: 'Verificado por', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'nc_e6', nome: 'Encerrada',
      camposVisiveisNoCard: ['nc_c1', 'nc_c3'],
      permiteCriarCards: false,
      campos: [
        { id: 'nc_c27', nome: 'Data do Encerramento', tipo: 'data', obrigatorio: false },
        { id: 'nc_c28', nome: 'Documentos Atualizados', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Procedimento', 'Instrução de trabalho', 'Formulário', 'Treinamento realizado', 'Nenhum'] },
        { id: 'nc_c29', nome: 'Observações Finais', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Contenção aplicada libera a análise de causa',
      etapaOrigemId: 'nc_e2',
      condicao: { campoId: 'nc_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'nc_e3',
    },
    {
      tipo: 'mover',
      nome: 'Ações concluídas seguem para verificação',
      etapaOrigemId: 'nc_e4',
      condicao: { campoId: 'nc_c21', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'nc_e5',
    },
    {
      tipo: 'mover',
      nome: 'Problema não voltou encerra a NC',
      etapaOrigemId: 'nc_e5',
      condicao: { campoId: 'nc_c24', operador: 'igual', valor: 'Não' },
      etapaDestinoId: 'nc_e6',
      etapaDestinoSenaoId: 'nc_e3',
    },
  ],
  cards: [
    { id: 'nc_card1', titulo: 'Entrega com item trocado', etapaId: 'nc_e3', etiquetas: ['Cliente'], valores: { nc_c1: 'Entrega com item trocado', nc_c3: 'Reclamação de cliente', nc_c4: 'Logística', nc_c5: 'Alta', nc_c14: 'Etiquetagem manual sem conferência dupla na separação.' } },
    { id: 'nc_card2', titulo: 'Falta de registro de treinamento', etapaId: 'nc_e4', etiquetas: ['Auditoria'], valores: { nc_c1: 'Falta de registro de treinamento', nc_c3: 'Auditoria externa', nc_c4: 'RH', nc_c5: 'Média', nc_c20: 70 } },
    { id: 'nc_card3', titulo: 'Fornecedor sem certificado válido', etapaId: 'nc_e2', valores: { nc_c1: 'Fornecedor sem certificado válido', nc_c3: 'Auditoria interna', nc_c4: 'Compras', nc_c5: 'Alta' } },
    { id: 'nc_card4', titulo: 'Divergência de estoque no inventário', etapaId: 'nc_e5', etiquetas: ['Reincidente'], valores: { nc_c1: 'Divergência de estoque no inventário', nc_c3: 'Processo produtivo', nc_c4: 'Logística', nc_c5: 'Média', nc_c8: 'Sim' } },
    { id: 'nc_card5', titulo: 'Atraso recorrente na emissão de NF', etapaId: 'nc_e6', valores: { nc_c1: 'Atraso recorrente na emissão de NF', nc_c3: 'Observação interna', nc_c4: 'Financeiro', nc_c5: 'Baixa' } },
    { id: 'nc_card6', titulo: 'Embalagem fora do padrão', etapaId: 'nc_e1', valores: { nc_c1: 'Embalagem fora do padrão', nc_c3: 'Fornecedor', nc_c4: 'Compras', nc_c5: 'Baixa' } },
  ],
  tour: [
    '✅ Não conformidade tratada de verdade — com causa raiz e verificação.',
    '1️⃣ "Registro": o que aconteceu, de onde veio e qual a severidade.',
    '2️⃣ "Contenção Imediata": apagar o incêndio primeiro (e registrar isso).',
    '3️⃣ "Análise de Causa Raiz": 5 porquês ou Ishikawa — sem isso, o problema volta.',
    '4️⃣ "Plano de Ação": o quê, quem e até quando, com barra de progresso.',
    '5️⃣ "Verificação de Eficácia": voltou a ocorrer? o card volta para a análise de causa.',
    '📋 "Encerrada" com registro de quais documentos foram atualizados — auditoria tranquila.',
  ],
  etapasDicas: [
    { quemFaz: 'Qualquer colaborador / Auditor', objetivo: 'Registrar o desvio com evidência.', conexoes: ['Receba NCs automaticamente do SAC quando a reclamação for de processo'] },
    { quemFaz: 'Responsável do processo', objetivo: 'Conter o efeito imediato e bloquear o que for necessário.', automacoes: ['Já configurado: contenção aplicada libera a análise'] },
    { quemFaz: 'Qualidade + Área', objetivo: 'Achar a causa real, não o culpado.' },
    { quemFaz: 'Responsável designado', objetivo: 'Executar a ação corretiva no prazo.', automacoes: ['Já configurado: ações concluídas seguem para verificação'] },
    { quemFaz: 'Qualidade', objetivo: 'Confirmar que a ação funcionou — se voltou, a causa estava errada.', automacoes: ['Já configurado: reincidência devolve para análise de causa'] },
    { quemFaz: 'Qualidade', objetivo: 'Encerrar com documentação atualizada.' },
  ],
};

const manutencao: DefaultTemplate = {
  id: 'tpl_manutencao',
  name: 'Manutenção & Facilities',
  descricao: 'Ordens de serviço de manutenção corretiva e preventiva com criticidade, diagnóstico, peças, execução e validação. Controla parada de máquina e custo por equipamento.',
  categoria: 'manutencao',
  icone: '🔧',
  etiquetas: [
    { nome: 'Máquina parada', cor: COR.vermelho },
    { nome: 'Preventiva', cor: COR.azul },
    { nome: 'Predial', cor: COR.ciano },
  ],
  etapas: [
    {
      id: 'mn_e1', nome: 'Abertura da OS',
      tempoMaximoHoras: 4,
      camposVisiveisNoCard: ['mn_c1', 'mn_c4', 'mn_c5'],
      permiteMoverPara: ['mn_e2'],
      campos: [
        { id: 'mn_c1', nome: 'Equipamento / Local', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'mn_c2', nome: 'Solicitante', tipo: 'texto', obrigatorio: true },
        { id: 'mn_c3', nome: 'Setor', tipo: 'lista', obrigatorio: true, opcoes: ['Produção', 'Administrativo', 'Almoxarifado', 'Expedição', 'Área externa', 'TI'] },
        { id: 'mn_c4', nome: 'Tipo de Manutenção', tipo: 'lista', obrigatorio: true, opcoes: ['Corretiva', 'Preventiva', 'Preditiva', 'Melhoria', 'Predial'], coresOpcoes: { 'Corretiva': COR.vermelho, 'Preventiva': COR.azul, 'Predial': COR.ciano } },
        { id: 'mn_c5', nome: 'Criticidade', tipo: 'lista', obrigatorio: true, opcoes: ['Baixa', 'Média', 'Alta', 'Urgente'], coresOpcoes: CORES_PRIORIDADE },
        { id: 'mn_c6', nome: 'Descrição do Problema', tipo: 'texto_longo', obrigatorio: true },
        { id: 'mn_c7', nome: 'Equipamento parado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mn_c8', nome: 'Foto', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'mn_e2', nome: 'Diagnóstico',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['mn_c1', 'mn_c10'],
      permiteMoverPara: ['mn_e3', 'mn_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'mn_c9', nome: 'Técnico Responsável', tipo: 'texto', obrigatorio: false },
        { id: 'mn_c10', nome: 'Causa Provável', tipo: 'texto_longo', obrigatorio: true },
        { id: 'mn_c11', nome: 'Precisa de peça?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mn_c12', nome: 'Peças Necessárias', tipo: 'texto_longo', obrigatorio: false },
        { id: 'mn_c13', nome: 'Custo Estimado', tipo: 'valor', obrigatorio: false },
      ],
    },
    {
      id: 'mn_e3', nome: 'Aguardando Peça',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['mn_c1', 'mn_c14'],
      permiteMoverPara: ['mn_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'mn_c14', nome: 'Previsão de Chegada', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'mn_c15', nome: 'Nº da Requisição de Compra', tipo: 'texto', obrigatorio: false },
        { id: 'mn_c16', nome: 'Peça chegou?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'mn_e4', nome: 'Em Execução',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['mn_c1', 'mn_c9', 'mn_c18'],
      permiteMoverPara: ['mn_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'mn_c17', nome: 'Serviço Executado', tipo: 'texto_longo', obrigatorio: true },
        { id: 'mn_c18', nome: 'Horas Trabalhadas', tipo: 'numero', obrigatorio: false },
        { id: 'mn_c19', nome: 'Custo Real', tipo: 'valor', obrigatorio: false },
        { id: 'mn_c20', nome: 'Serviço concluído?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mn_c21', nome: 'Foto do Serviço', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'mn_e5', nome: 'Validação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['mn_c1', 'mn_c22'],
      permiteMoverPara: ['mn_e6', 'mn_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'mn_c22', nome: 'Solicitante validou?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mn_c23', nome: 'Observações da Validação', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'mn_e6', nome: 'Concluída',
      camposVisiveisNoCard: ['mn_c1', 'mn_c19'],
      permiteCriarCards: false,
      campos: [
        { id: 'mn_c24', nome: 'Data da Conclusão', tipo: 'data', obrigatorio: false },
        { id: 'mn_c25', nome: 'Gerar preventiva recorrente?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'mn_c26', nome: 'Periodicidade Sugerida', tipo: 'lista', obrigatorio: false, opcoes: ['Mensal', 'Trimestral', 'Semestral', 'Anual'] },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Precisa de peça vai para a fila de espera',
      etapaOrigemId: 'mn_e2',
      condicao: { campoId: 'mn_c11', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mn_e3',
      etapaDestinoSenaoId: 'mn_e4',
    },
    {
      tipo: 'mover',
      nome: 'Peça chegou libera a execução',
      etapaOrigemId: 'mn_e3',
      condicao: { campoId: 'mn_c16', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mn_e4',
    },
    {
      tipo: 'mover',
      nome: 'Serviço concluído vai para validação',
      etapaOrigemId: 'mn_e4',
      condicao: { campoId: 'mn_c20', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mn_e5',
    },
    {
      tipo: 'mover',
      nome: 'Solicitante validou encerra a OS',
      etapaOrigemId: 'mn_e5',
      condicao: { campoId: 'mn_c22', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'mn_e6',
      etapaDestinoSenaoId: 'mn_e4',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar peças necessárias quando precisar',
      etapaOrigemId: 'mn_e2',
      condicao: { campoId: 'mn_c11', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['mn_c12'],
    },
  ],
  cards: [
    { id: 'mn_card1', titulo: 'Compressor de ar - linha 2', etapaId: 'mn_e3', etiquetas: ['Máquina parada'], valores: { mn_c1: 'Compressor de ar - linha 2', mn_c3: 'Produção', mn_c4: 'Corretiva', mn_c5: 'Urgente', mn_c7: 'Sim', mn_c11: 'Sim', mn_c13: 3800 } },
    { id: 'mn_card2', titulo: 'Ar-condicionado - sala de reunião', etapaId: 'mn_e4', etiquetas: ['Predial'], valores: { mn_c1: 'Ar-condicionado - sala de reunião', mn_c3: 'Administrativo', mn_c4: 'Predial', mn_c5: 'Média', mn_c7: 'Não' } },
    { id: 'mn_card3', titulo: 'Empilhadeira - revisão 500h', etapaId: 'mn_e6', etiquetas: ['Preventiva'], valores: { mn_c1: 'Empilhadeira - revisão 500h', mn_c3: 'Expedição', mn_c4: 'Preventiva', mn_c5: 'Baixa', mn_c19: 1450, mn_c25: 'Sim', mn_c26: 'Trimestral' } },
    { id: 'mn_card4', titulo: 'Vazamento no telhado do almoxarifado', etapaId: 'mn_e2', valores: { mn_c1: 'Vazamento no telhado do almoxarifado', mn_c3: 'Almoxarifado', mn_c4: 'Corretiva', mn_c5: 'Alta', mn_c7: 'Não' } },
    { id: 'mn_card5', titulo: 'Portão eletrônico da entrada', etapaId: 'mn_e5', valores: { mn_c1: 'Portão eletrônico da entrada', mn_c3: 'Área externa', mn_c4: 'Corretiva', mn_c5: 'Média', mn_c18: 3 } },
    { id: 'mn_card6', titulo: 'Iluminação do estacionamento', etapaId: 'mn_e1', etiquetas: ['Predial'], valores: { mn_c1: 'Iluminação do estacionamento', mn_c3: 'Área externa', mn_c4: 'Predial', mn_c5: 'Baixa', mn_c7: 'Não' } },
  ],
  tour: [
    '🔧 Ordem de serviço com criticidade, custo e validação de quem pediu.',
    '1️⃣ "Abertura da OS": equipamento, tipo e se está parado — SLA de 4h para triagem.',
    '2️⃣ "Diagnóstico": causa provável e se precisa de peça.',
    '3️⃣ Precisa de peça? o card vai sozinho para "Aguardando Peça" com previsão de chegada.',
    '4️⃣ "Em Execução": serviço, horas trabalhadas e custo real.',
    '5️⃣ "Validação": quem pediu confirma. Não validou? volta para execução.',
    '🔁 No encerramento você marca se vira preventiva recorrente — e com qual periodicidade.',
  ],
  etapasDicas: [
    { quemFaz: 'Qualquer setor', objetivo: 'Abrir a OS com foto — descrição de máquina parada nunca é clara o suficiente.' },
    { quemFaz: 'Técnico de manutenção', objetivo: 'Diagnosticar e dizer se precisa de peça.', automacoes: ['Já configurado: precisa de peça vai para a fila de espera'] },
    { quemFaz: 'Manutenção + Compras', objetivo: 'Acompanhar a compra da peça sem perder a OS de vista.', conexoes: ['Ligue à Requisição de Compra para comprar a peça'] },
    { quemFaz: 'Técnico', objetivo: 'Executar e registrar horas e custo — base do custo por equipamento.' },
    { quemFaz: 'Solicitante', objetivo: 'Confirmar que resolveu antes de fechar.', automacoes: ['Já configurado: não validou volta para execução'] },
    { quemFaz: 'Manutenção', objetivo: 'Transformar corretiva recorrente em preventiva programada.' },
  ],
};

export const TEMPLATES_MARKETING: DefaultTemplate[] = [campanhasMarketing];
export const TEMPLATES_LOGISTICA: DefaultTemplate[] = [controleEstoque];
export const TEMPLATES_QUALIDADE: DefaultTemplate[] = [naoConformidades];
export const TEMPLATES_MANUTENCAO: DefaultTemplate[] = [manutencao];
